var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2259 2.40771C12.6161 2.01683 13.249 2.01653 13.6395 2.40706L15.7563 4.52389C16.1468 4.91441 16.1471 5.54787 15.757 5.93876L8.83139 12.8772C8.69593 13.0129 8.52435 13.1067 8.33709 13.1476L5.6348 13.7369C4.92401 13.892 4.29113 13.2593 4.44511 12.5476L5.03069 9.84132C5.07128 9.65372 5.16493 9.48177 5.30047 9.34598L12.2259 2.40771Z",
    stroke: "#FF9900",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2867 4.70386L13.8178 8.2349",
    stroke: "#FF9900",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49548 17.8479H15.9955",
    stroke: "#FF9900",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9813cbf5eb0f020cb0389d79d87d886a.svg";
export { ForwardRef as ReactComponent };